import { render, staticRenderFns } from "./withdraw_reject_reasons.vue?vue&type=template&id=0b394ec8&scoped=true&"
import script from "./withdraw_reject_reasons.vue?vue&type=script&lang=js&"
export * from "./withdraw_reject_reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b394ec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b394ec8')) {
      api.createRecord('0b394ec8', component.options)
    } else {
      api.reload('0b394ec8', component.options)
    }
    module.hot.accept("./withdraw_reject_reasons.vue?vue&type=template&id=0b394ec8&scoped=true&", function () {
      api.rerender('0b394ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/withdraw_reject_reasons.vue"
export default component.exports